import { Text } from '@consta/uikit/Text'
import type { FC } from 'react'

type StatisticsRowProps = { label: string; value: number }

export const StatisticsRow: FC<StatisticsRowProps> = ({ label, value }) => (
  <>
    <Text size="xs" view="secondary">
      {label}
    </Text>
    <Text size="xs" view="primary">
      {Number.isInteger(value) ? value : value.toFixed(2)}
    </Text>
  </>
)
